const STORAGE_KEY = "lazystudio.appPreferences";

export const DEFAULT_APP_PREFERENCES = {
  defaultDownloadFormat: "png",
  confirmBeforeDelete: true,
  showToolCreditCosts: true,
  autoRestoreEditorSession: true,
  reduceMotion: false,
  productEmailUpdates: false,
};

export const DOWNLOAD_FORMAT_OPTIONS = [
  { value: "png", label: "PNG" },
  { value: "jpeg", label: "JPEG" },
  { value: "webp", label: "WebP" },
];

const isObject = (value) =>
  value != null && typeof value === "object" && !Array.isArray(value);

export const normalizeAppPreferences = (input = {}) => {
  const next = { ...DEFAULT_APP_PREFERENCES, ...(isObject(input) ? input : {}) };

  const format = String(next.defaultDownloadFormat || "png").toLowerCase();
  next.defaultDownloadFormat = DOWNLOAD_FORMAT_OPTIONS.some((o) => o.value === format)
    ? format
    : "png";

  next.confirmBeforeDelete = Boolean(next.confirmBeforeDelete);
  next.showToolCreditCosts = Boolean(next.showToolCreditCosts);
  next.autoRestoreEditorSession = Boolean(next.autoRestoreEditorSession);
  next.reduceMotion = Boolean(next.reduceMotion);
  next.productEmailUpdates = Boolean(next.productEmailUpdates);

  return next;
};

export const getAppPreferences = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT_APP_PREFERENCES };
    return normalizeAppPreferences(JSON.parse(raw));
  } catch {
    return { ...DEFAULT_APP_PREFERENCES };
  }
};

export const setAppPreferences = (prefs) => {
  const next = normalizeAppPreferences(prefs);
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // ignore quota / private mode
  }
  applyAppPreferences(next);
  return next;
};

export const updateAppPreferences = (partial) =>
  setAppPreferences({ ...getAppPreferences(), ...partial });

/** Apply prefs that affect the live document (safe to call on boot). */
export const applyAppPreferences = (prefs = getAppPreferences()) => {
  const next = normalizeAppPreferences(prefs);
  if (typeof document === "undefined") return next;
  document.documentElement.dataset.reduceMotion = next.reduceMotion
    ? "true"
    : "false";
  return next;
};
